import {
    COMMENTS_LIST_REQUEST,
    COMMENTS_LIST_SUCCESS,
    COMMENTS_LIST_FAILED,
    COMMENTS_LIST_RESET,
} from './commentConstants'

export const commentListReducer = (state = {
    comments: [],
    totalPages: 0,
}, action) => {
    switch (action.type) {
        case COMMENTS_LIST_REQUEST:
            return {
                cLoading: true,
                ...state
            }
        case COMMENTS_LIST_SUCCESS:
            return {
                cLoading: false,
                comments: action.payload.comments,
                totalPages: action.payload.totalPages,
            }
        case COMMENTS_LIST_FAILED:
            return { cLoading: false, cError: action.payload }
        case COMMENTS_LIST_RESET:
            return { loading: true }
        default:
            return state
    }
}
